import dayjs from "dayjs";

const COOKIE_FIELD = "__access_page_state";

const setCookie = (name, value, days = 7) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(
    value
  )};expires=${expires.toUTCString()};path=/`;
};

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return decodeURIComponent(parts.pop().split(";").shift());
  }

  return null;
};

const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
};

const serialize = (value) => {
  if (dayjs.isDayjs(value)) {
    return { __type: "dayjs", value: value.toISOString() };
  }

  if (Array.isArray(value)) {
    if (value.length === 2 && dayjs.isDayjs(value[0]) && dayjs.isDayjs(value[1])) {
      return {
        __type: "dayjs_range",
        value: [value[0].toISOString(), value[1].toISOString()],
      };
    }

    return value.map(serialize);
  }

  if (value && typeof value === "object") {
    const output = {};

    Object.keys(value).forEach((key) => {
      output[key] = serialize(value[key]);
    });

    return output;
  }

  return value;
};

const revive = (value) => {
  if (Array.isArray(value)) {
    return value.map(revive);
  }

  if (value && typeof value === "object") {
    if (value.__type === "dayjs") {
      return dayjs(value.value);
    }

    if (value.__type === "dayjs_range") {
      return value.value.map((item) => dayjs(item));
    }

    const output = {};

    Object.keys(value).forEach((key) => {
      output[key] = revive(value[key]);
    });

    return output;
  }

  return value;
};

const buildCookieName = (pageKey) => `${pageKey}_${COOKIE_FIELD}`;

export const saveAccessPageStateCookie = (pageKey, value, days = 7) => {
  try {
    setCookie(buildCookieName(pageKey), JSON.stringify(serialize(value)), days);
  } catch (error) {
    console.warn("Failed to save access page state cookie:", error);
  }
};

export const loadAccessPageStateCookie = (pageKey) => {
  try {
    const json = getCookie(buildCookieName(pageKey));

    if (!json) {
      return null;
    }

    return revive(JSON.parse(json));
  } catch (error) {
    console.warn("Failed to load access page state cookie:", error);
    return null;
  }
};

export const clearAccessPageStateCookie = (pageKey) => {
  deleteCookie(buildCookieName(pageKey));
};